export const APICONSTANT = {
  LICENSE_DETAILS: '/v1/ccsp/licenses/',
  EMPLOYEE_NAME: '/v1/employees/',
  SSN_INDICATOR: '/v1/ccsp/country/',
  STATES: '/v1/ccsp/states/',
  COUNTRIES: '/v1/ccsp/countries/',
  COUNRTY_STATE_MAPPING: '/v1/ccsp/country-state-mappings/',
  RELATION_TO_EMPLOYEE: '/v1/ccsp/relationships/',
  VA_WEBSERVICE: '/v1/employees/',
  PARAMETER: '/v1/ccsp/params/',
  MVR_SCORE: '/v1/ccsp/mvr/employees/',
  EXPORT_EMPLOYEE_LIST: '/v1/ccsp/mvr/mvrEmployeesExport/',
  EMPLOYEE_LIST: '/v1/ccsp/mvr/mvrEmployees',
  CCSP_VEHICLE_HISTORY: '/v1/ccsp/vehicle-history/employees/',
  CCSP_EMPLOYEE_VEHICLE_ORDER_HISTORY:
    '/v1/ccsp/vehicle-request/order-details/employee/',
  UPLOAD_CONSENT: '/v1/ccsp/consent/authorized-users/',
  USER_INFO: '/userinfo',
  SEARCH_CONSENT_FOR_EMPLOYEE: '/v1/ccsp/employees/employee',
  VIEW_CONSENT_DETAILS: '/v1/ccsp/employees/',
  MODEL_CODE: '/v1/ccsp/model-program-codes',
  SAVE_TEMP_LICENSES: '/v1/ccsp/temp-licenses',
  IMPORT_MODEL_PAREMETER: '/v1/ccsp/model-program-codes/import',
  IMPORT_AND_REPLACE_MODEL_PAREMETER: '/v1/ccsp/model-program-codes/add',
  SEND_EMAIL: '/v1/ccsp/consent/authorized-users/consentemail',
  PENDING_UNASSIGNED_VEHICLE_REQUESTS:
    '/v1/ccsp/vehicle-requests/pending-unassigned/',
  COMPLETED_VEHICLE_REQUESTS: '/v1/ccsp/vehicle-requests/completed/',
  IN_PROGRESS_VEHICLE_REQUESTS: '/v1/ccsp/vehicle-requests/in-progress/',
  ACCEPT_ORDER: '/v1/ccsp/accept-order',
  PROCESS_ORDER: '/v1/ccsp/process-order',
  MOVE_ORDER_TO_UNASSINGED_STATE: '/v1/ccsp/move-order-to-unassigned-state',
  MOVE_ORDER_TO_IN_PROGRESS_STATE: '/v1/ccsp/move-order-to-in-progress-state',
  REACTIVATE_AUTHORIZED_USER: '/v1/ccsp/reactivate-licenses/',
  UPLOAD_CONSENT_VIA_CONSENT_ADMIN_FOR_AUTHORIZED_USER:
    '/v1/ccsp/consent/admin/authorized-users',
  GET_SELECTED_MODLES_FOR_PROGRAM_CODE: '/v1/ccsp/vehicle-request/model-codes/',
  PLACE_ORDER_FOR_NEXT_VEHICLE: '/v1/ccsp/vehicle-request/place-order/',
};
